<template>
  <div class="wrapper">
    <div class="d-flex flex-column bg-light h-100">
      <div id="navbar">
        <div class="bg-nitro p-3 text-center d-md-none">
          <router-link
            :to="{
              name: homeRouteName
            }"
          >
            <img
              src="/images/logo-default.svg"
              alt="Nitro Logo"
              style="width: auto; height: 40px;"
            >
          </router-link>
        </div>

        <v-sheet class="d-flex flex-column flex-md-row navbar navbar-light bg-nitro">
          <div class="align-items-center d-flex flex-column-reverse flex-md-row">
            <span
              class="bg-white d-none justify-content-center align-items-center ml-n4 my-n2 mr-6 d-md-flex"
              style="width:84px;height:66px"
            >
              <router-link
                :to="{ name: homeRouteName }"  
              >
                <img
                  src="/images/logo-default.svg"
                  alt="Nitro Logo"
                  style="width: auto; height: 40px;"
                >
              </router-link>
            </span>
            <a
              v-if="showTrailHeader"
              class="align-items-center d-flex font-weight-bolder navbar-brand text-white"
            >
              <span class="trail-icon mr-3">
                <img
                  :src="`/${authUser.current_trail.icon.url}`"
                  :alt="authUser.current_trail.name"
                  style="filter: brightness(1) invert(1)"
                >
              </span>
              <span class="align-middle">
                {{ authUser.current_trail.name }}
              </span>
            </a>
          </div>
          <div class="d-none d-md-flex d-flex justify-content-around align-items-center " />
          <PlatformList />
        </v-sheet>
      </div>
      <router-view />
    </div>
  </div>
</template>
<script>

import {mapGetters } from 'vuex'
import PlatformList from "@/common/components/PlatformList.vue"
import { homeRouteName } from '../constants/routes';

export default {
  components: {
    PlatformList
  },
  data(){
    return {
      homeRouteName
    }
  },
  computed: {
    ...mapGetters(['authUser','school']),
    showTrailHeader() {
      return this.authUser && this.authUser.current_trail
    }
  },
}
</script>
